// ============================================================
// Weather Center helpers + radar timeline constants. Icon mapping and
// bar-color helpers are shared; all weather values come from the live API.
// ============================================================

// -- Xweather icon mapping --
const iconMap = {
  bkn: 'mcloudy',
  few: 'pcloudy',
  skc: 'sunny',
  sct: 'pcloudy',
  ovc: 'cloudy',
  shra: 'showers',
  tsra: 'tstorm',
  hi_shwrs: 'pcloudyr',
  nbkn: 'mcloudyn',
  nfew: 'pcloudyn',
  nskc: 'clearn',
  nsct: 'pcloudyn',
};

export function getIconUrl(code) {
  return `https://cdn.aerisapi.com/wxblox/icons/${iconMap[code] || code}.png`;
}

export function getBarColor(a) {
  if (a <= 0) return 'var(--rain-none)';
  if (a < 0.1) return 'var(--rain-light)';
  if (a < 0.25) return 'var(--rain-moderate)';
  if (a < 0.5) return 'var(--rain-heavy)';
  return 'var(--rain-extreme)';
}


// ============================================================
// Radar playback timeline
// ============================================================
// Radar playback frames — relative minute offsets from "now". Absolute clock
// times are computed live in the component from the real current time + offset.
export const RADAR_FRAMES = [
  { mins: -60, label: '-60m' },
  { mins: -50, label: '-50m' },
  { mins: -40, label: '-40m' },
  { mins: -30, label: '-30m' },
  { mins: -20, label: '-20m' },
  { mins: -10, label: '-10m' },
  { mins: 0, label: 'NOW' },
  { mins: 15, label: '+15', future: true },
  { mins: 30, label: '+30', future: true },
  { mins: 45, label: '+45', future: true },
  { mins: 60, label: '+1h', future: true },
  { mins: 90, label: '+90', future: true },
  { mins: 120, label: '+2h', future: true },
];

export const NOW_INDEX = RADAR_FRAMES.findIndex((f) => f.mins === 0);
export const LAST_FRAME = RADAR_FRAMES.length - 1;
const TIME_MIN = RADAR_FRAMES[0].mins;
const TIME_MAX = RADAR_FRAMES[LAST_FRAME].mins;
const TIME_SPAN = TIME_MAX - TIME_MIN;

export const framePos = (idx) => ((RADAR_FRAMES[idx].mins - TIME_MIN) / TIME_SPAN) * 100;
